const parsedBuild = Number(import.meta.env.VITE_ALFREC_WEB_BUILD ?? '1');

export const compiledAppBuild =
  Number.isSafeInteger(parsedBuild) && parsedBuild > 0 ? parsedBuild : 1;

export const tabAppBuild = (): number => {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const raw = new URLSearchParams(window.location.search).get('appBuild');
    if (raw && /^[1-9]\d*$/.test(raw)) {
      return Number(raw);
    }
  }
  return compiledAppBuild;
};
